import React from 'react'
import { PageComponentProps } from '../../Router/Interfaces'

export default function NotFoundPage(props: PageComponentProps) {
    return(
        <div>
            404
        </div>
    )
}